import React from 'react';
import '../template-file-css/document-file-template.css';


export const LHH_WeeklyProgressNote = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LHH_WeeklyProgressNote' className='file-pdf-document'>

            <div className='file-template'>

                <p className='w-750'>
                    Attendance during month of &nbsp;
                    <input type='text' id='txtAttendanceMonth_1' name='txtAttendanceMonth_1' className='add-only w-200 custom-add-only' />
                    &nbsp;
                    in the year of &nbsp;
                    <input type='text' id='txtAttendanceYear_1' name='txtAttendanceYear_1' className='add-only w-200 custom-add-only' />


                </p>

                <table>

                    <tr>
                        <td className='w-50'> <span className='eleHeader'>Days:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Time In:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Time Out:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Total Time:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>1</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_1' name='TimeIn_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_1' name='TimeOu_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_1' name='TotaTi_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>2</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_2' name='TimeIn_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_2' name='TimeOu_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_2' name='TotaTi_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>3</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_3' name='TimeIn_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_3' name='TimeOu_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_3' name='TotaTi_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>4</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_4' name='TimeIn_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_4' name='TimeOu_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_4' name='TotaTi_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>5</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_5' name='TimeIn_5' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_5' name='TimeOu_5' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_5' name='TotaTi_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>6</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_6' name='TimeIn_6' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_6' name='TimeOu_6' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_6' name='TotaTi_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>7</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_7' name='TimeIn_7' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_7' name='TimeOu_7' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_7' name='TotaTi_7' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>8</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_8' name='TimeIn_8' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_8' name='TimeOu_8' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_8' name='TotaTi_8' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>9</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_9' name='TimeIn_9' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_9' name='TimeOu_9' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_9' name='TotaTi_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>10</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_0' name='TimeIn_0' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_0' name='TimeOu_0' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_0' name='TotaTi_0' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-50'>  <center><b>11</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_11' name='TimeIn_11' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_11' name='TimeOu_11' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_11' name='TotaTi_11' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>12</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_12' name='TimeIn_12' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_12' name='TimeOu_12' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_12' name='TotaTi_12' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>13</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_13' name='TimeIn_13' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_13' name='TimeOu_13' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_13' name='TotaTi_13' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>14</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_14' name='TimeIn_14' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_14' name='TimeOu_14' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_14' name='TotaTi_14' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>15</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_15' name='TimeIn_15' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_15' name='TimeOu_15' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_15' name='TotaTi_15' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>16</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_16' name='TimeIn_16' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_16' name='TimeOu_16' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_16' name='TotaTi_16' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>17</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_17' name='TimeIn_17' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_17' name='TimeOu_17' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_17' name='TotaTi_17' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>18</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_18' name='TimeIn_18' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_18' name='TimeOu_18' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_18' name='TotaTi_18' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>19</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_19' name='TimeIn_19' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_19' name='TimeOu_19' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_19' name='TotaTi_19' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>20</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_10' name='TimeIn_10' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_10' name='TimeOu_10' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_10' name='TotaTi_10' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-50'>  <center><b>21</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_21' name='TimeIn_21' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_21' name='TimeOu_21' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_21' name='TotaTi_21' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>22</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_22' name='TimeIn_22' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_22' name='TimeOu_22' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_22' name='TotaTi_22' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>23</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_23' name='TimeIn_23' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_23' name='TimeOu_23' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_23' name='TotaTi_23' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>24</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_24' name='TimeIn_24' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_24' name='TimeOu_24' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_24' name='TotaTi_24' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>25</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_25' name='TimeIn_25' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_25' name='TimeOu_25' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_25' name='TotaTi_25' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>26</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_26' name='TimeIn_26' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_26' name='TimeOu_26' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_26' name='TotaTi_26' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>27</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_27' name='TimeIn_27' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_27' name='TimeOu_27' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_27' name='TotaTi_27' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>28</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_28' name='TimeIn_28' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_28' name='TimeOu_28' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_28' name='TotaTi_28' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>29</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_29' name='TimeIn_29' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_29' name='TimeOu_29' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_29' name='TotaTi_29' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>20</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_30' name='TimeIn_30' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_30' name='TimeOu_30' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_30' name='TotaTi_30' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'>  <center><b>31</b></center> </td>
                        <td className='w-250'> <input type='time' id='TimeIn_31' name='TimeIn_31' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='TimeOu_31' name='TimeOu_31' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='TotaTi_31' name='TotaTi_31' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <center>
                        <b>Summary of Objective/Activity</b>
                    </center>

                </p>

                <p className='w-750'>
                    <b> 1<sup>st</sup> Week </b>
                    <span className='eleHeader'>Objectives (s):</span>
                    <textarea id='txtObjectives_1' name='txtObjectives_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>S:</span>
                    <textarea id='txtS_1' name='txtS_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>A:</span>
                    <textarea id='txtA_1' name='txtA_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>P:</span>
                    <textarea id='txtP_1' name='txtP_1' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-500'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Date: </td>
                        <td className='small w-500'> Signature/Credentials </td>
                    </tr>
                </table>

<p className='w-750'>
    <b> 2<sup>nd</sup> Week </b>
    <span className='eleHeader'>Objectives (s):</span>
    <textarea id='txtObjectives_2' name='txtObjectives_2' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>S:</span>
    <textarea id='txtS_2' name='txtS_2' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>A:</span>
    <textarea id='txtA_2' name='txtA_2' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>P:</span>
    <textarea id='txtP_2' name='txtP_2' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='signature w-250'>&nbsp; </td>
        <td className='signature w-500'>&nbsp; </td>
    </tr>
    <tr>
        <td className='small w-250'> Date: </td>
        <td className='small w-500'> Signature/Credentials </td>
    </tr>
</table>

<p className='w-750'>
    <b> 3<sup>rd</sup> Week </b>
    <span className='eleHeader'>Objectives (s):</span>
    <textarea id='txtObjectives_3' name='txtObjectives_3' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>S:</span>
    <textarea id='txtS_3' name='txtS_3' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>A:</span>
    <textarea id='txtA_3' name='txtA_3' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>P:</span>
    <textarea id='txtP_3' name='txtP_3' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='signature w-250'>&nbsp; </td>
        <td className='signature w-500'>&nbsp; </td>
    </tr>
    <tr>
        <td className='small w-250'> Date: </td>
        <td className='small w-500'> Signature/Credentials </td>
    </tr>
</table>

<p className='w-750'>
    <b> 4<sup>th</sup> Week </b>
    <span className='eleHeader'>Objectives (s):</span>
    <textarea id='txtObjectives_4' name='txtObjectives_4' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>S:</span>
    <textarea id='txtS_4' name='txtS_4' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>A:</span>
    <textarea id='txtA_4' name='txtA_4' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>P:</span>
    <textarea id='txtP_4' name='txtP_4' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='signature w-250'>&nbsp; </td>
        <td className='signature w-500'>&nbsp; </td>
    </tr>
    <tr>
        <td className='small w-250'> Date: </td>
        <td className='small w-500'> Signature/Credentials </td>
    </tr>
</table>

                <p className='w-750'>
                    <b> 5<sup>th</sup> Week </b>
                    <span className='eleHeader'>Objectives (s):</span>
                    <textarea id='txtObjectives_5' name='txtObjectives_5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>S:</span>
                    <textarea id='txtS_5' name='txtS_5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>A:</span>
                    <textarea id='txtA_5' name='txtA_5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>P:</span>
                    <textarea id='txtP_5' name='txtP_5' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-500'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Date: </td>
                        <td className='small w-500'> Signature/Credentials </td>
                    </tr>
                </table>

                
                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-500'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Date: </td>
                        <td className='small w-500'> Staff Signature/Credentials </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-500'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Date: </td>
                        <td className='small w-500'> Supervisor Signature/Credentials </td>
                    </tr>
                </table>

 


            </div>
        </form>

    )
}







